"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigPayload = exports.Config = exports.CommandQueued = exports.CommandSent = exports.CommandPayload = exports.UpdatePayload = exports.CreatePayload = exports.DashboardDeviceList = exports.DashboardDevice = exports.DeviceList = exports.Device = exports.StateLookupFailed = exports.DeviceState = exports.LatestData = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../json"));
const field_1 = require("../../../openapi/field");
const schema_1 = require("../../admin/device/command/schema");
const schema_2 = require("../../admin/device/registry/schema");
exports.NAMESPACE = 'Culligan.Api.V1.Frontend.Device.Schema';
exports.LatestData = effect_1.Schema.Struct({
    datapoints: effect_1.Schema.propertySignature(Json.Record).annotations({
        description: 'Telemetry merged with state; state wins when a key is in both',
    }),
    lastUpdate: effect_1.Schema.propertySignature((0, field_1.dateTime)('Time of the last write by the data intake function, not the time of a datapoint; a manual insert through the admin API does not move it')),
}).annotations({
    identifier: `${exports.NAMESPACE}.LatestData`,
});
/** The handler writes this placeholder, not a real time, for fields it does not read yet. */
const NotTracked = effect_1.Schema.Literal('0000-00-00T00:00:00.000Z').annotations({
    description: 'Fixed placeholder; the value is not read yet',
});
// The azure-iothub Device always sets both times, null when the hub has no value.
const hubTime = (description) => effect_1.Schema.propertySignature(effect_1.Schema.NullOr((0, field_1.dateTime)(description))).annotations({
    description: `${description}. Null when the IoT Hub lookup fails or the hub has no value`,
});
exports.DeviceState = effect_1.Schema.Struct({
    serialNumber: (0, field_1.nonEmpty)('Device serial number'),
    info: effect_1.Schema.propertySignature(effect_1.Schema.Struct({
        manufacturerName: effect_1.Schema.String,
        modelName: effect_1.Schema.String,
        version: effect_1.Schema.String,
        type: effect_1.Schema.String,
    })).annotations({
        description: 'Labels of the device class found from the model code; "Culligan", "Generic Water Device" and "generic" when the model is unknown. A device stored without a model code is 500',
    }),
    connected: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        description: 'True when the stored status says online. For any other device the live Device Twin decides, and a failed IoT Hub read there is 500',
    }),
    region: effect_1.Schema.propertySignature(effect_1.Schema.Struct({ code: effect_1.Schema.NullOr(effect_1.Schema.String) })),
    params: effect_1.Schema.propertySignature(effect_1.Schema.Struct({
        protocolVersion: effect_1.Schema.Number,
    })).annotations({ description: 'Stored protocol version, 1 when the device has none' }),
    errors: effect_1.Schema.propertySignature(effect_1.Schema.Array(Json.Value)).annotations({
        description: 'The last stored error content when its lastUpdate is above zero, otherwise an empty list',
    }),
    alerts: effect_1.Schema.propertySignature(effect_1.Schema.Array(Json.Value)).annotations({
        description: 'Always an empty list',
    }),
    lastHeartbeatTime: hubTime('Last IoT Hub activity time'),
    lastEventTime: hubTime('Same value as lastHeartbeatTime; the real event time is not read yet'),
    lastConfigAckTime: effect_1.Schema.propertySignature(NotTracked),
    lastConfigSendTime: effect_1.Schema.propertySignature(NotTracked),
    lastStateTime: hubTime('Time the IoT Hub enabled or disabled status of the device last changed'),
    lastErrorTime: effect_1.Schema.propertySignature(NotTracked),
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceState`,
});
exports.StateLookupFailed = effect_1.Schema.Struct({
    status: effect_1.Schema.Literal(404),
    body: effect_1.Schema.Struct({
        success: effect_1.Schema.Literal(false),
        error: effect_1.Schema.Struct({ message: effect_1.Schema.Literal('NOT_FOUND') }),
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.StateLookupFailed`,
    description: 'Failed response built when the device record cannot be read, sent inside a 200',
});
const storedStatus = effect_1.Schema.propertySignature(Json.Record).annotations({
    description: 'Stored status bag; carries connection { online, lastUpdate } and may carry more keys on older records. On /registry/details and /registry/list connection.lastUpdate is always null, because the controller parses the record a second time',
});
// Times are stored as an ISO string or as epoch milliseconds, whichever wrote the record.
const storedTime = (description) => effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.Union((0, field_1.dateTime)(description), effect_1.Schema.Number))).annotations({
    description,
});
const optionalStoredTime = (description) => effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Union((0, field_1.dateTime)(description), effect_1.Schema.Number)), { exact: true }).annotations({
    description,
});
exports.Device = effect_1.Schema.Struct({
    serialNumber: (0, field_1.nonEmpty)('Device serial number'),
    name: (0, field_1.optionalNullableString)('Device display name'),
    model: (0, field_1.optionalNullableString)('Legacy model code'),
    generation: effect_1.Schema.propertySignature(effect_1.Schema.Literal(2)).annotations({ description: 'Always 2' }),
    protocolVersion: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Number), { exact: true }),
    lat: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.Number)),
    lon: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.Number)),
    swVersion: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(Json.Value)),
    status: storedStatus,
    region: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.Struct({ code: effect_1.Schema.String }))).annotations({
        description: 'Region object, or null when the device has no region code',
    }),
    metaData: effect_1.Schema.propertySignature(Json.Record).annotations({
        description: 'User-defined metadata, an empty object when there is none',
    }),
    registeredAt: storedTime('Registration time, null when never registered'),
    createdAt: storedTime('Creation time, null when not stored'),
    updatedAt: storedTime('Last update time, null when not stored'),
    currentUserRole: effect_1.Schema.propertySignature(effect_1.Schema.Literal('owner', 'admin', 'dealer', 'user', 'auditor')).annotations({
        description: 'Role of the caller on this device: owner for owned devices, the sharing role (user when none is stored) for shared ones',
    }),
    dealerId: (0, field_1.nullableString)('Dealer id, trimmed'),
    tenantId: (0, field_1.nullableString)('Tenant id'),
    accountNumber: (0, field_1.nullableString)('Dealer account number'),
    installationAddress: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(schema_2.InstallationAddress)),
    contactInfo: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(schema_2.ContactInfo)),
    properties: effect_1.Schema.propertySignature(Json.Record).annotations({
        description: 'Raw device properties as a key-value object, empty when none',
    }),
    ownerId: (0, field_1.optionalNullableString)('Owner user id. Present only when currentUserRole is admin, dealer or auditor'),
}).annotations({
    identifier: `${exports.NAMESPACE}.Device`,
    description: 'Device as listed by GET /registry',
});
exports.DeviceList = effect_1.Schema.Struct({
    devices: effect_1.Schema.propertySignature(effect_1.Schema.Array(exports.Device)).annotations({
        description: 'Owned devices first, then devices shared with the caller',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceList`,
});
exports.DashboardDevice = effect_1.Schema.Struct({
    id: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString, { exact: true }).annotations({
        description: 'Stored device id. Present on /registry/details only',
    }),
    serialNumber: (0, field_1.nonEmpty)('Device serial number'),
    name: (0, field_1.optionalNullableString)('Device display name'),
    ownerId: (0, field_1.optionalNullableString)('Owner user id'),
    dealerId: (0, field_1.optionalNullableString)('Dealer id, trimmed'),
    tenantId: (0, field_1.optionalNullableString)('Tenant id'),
    model: (0, field_1.optionalNullableString)('Legacy model code'),
    lat: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Number), { exact: true }),
    lon: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Number), { exact: true }),
    registrationToken: (0, field_1.optionalNullableString)('Registration token. Present on /registry/details only'),
    protocolVersion: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Number), { exact: true }),
    swVersion: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(Json.Value)),
    status: storedStatus,
    region: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.String)).annotations({
        description: 'Region code string, or null when the device has no region; GET /registry returns an object instead. Always null on /registry/details, because the controller parses the record a second time',
    }),
    registeredAt: optionalStoredTime('Registration time'),
    createdAt: optionalStoredTime('Creation time'),
    updatedAt: optionalStoredTime('Last update time'),
    installationAddress: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(schema_2.InstallationAddress), { exact: true }).annotations({
        description: 'When the device has contactInfo, mobilePhoneNumber, contactName and email are filled from it for older clients',
    }),
    contactInfo: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(schema_2.ContactInfo), { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.DashboardDevice`,
    description: 'Device as returned by GET /registry/list and GET /registry/details',
});
exports.DashboardDeviceList = effect_1.Schema.Struct({
    items: effect_1.Schema.propertySignature(effect_1.Schema.Array(exports.DashboardDevice)).annotations({
        description: 'Owned devices first, then devices shared with the caller',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.DashboardDeviceList`,
});
const contactAndAddressFields = {
    dealerId: (0, field_1.optionalString)('Dealer id; surrounding spaces are trimmed'),
    manufacturingSerialNumber: (0, field_1.optionalString)('Manufacturing serial number'),
    sku: (0, field_1.optionalString)('Device SKU'),
    accountNumber: (0, field_1.optionalString)('Dealer account number'),
    address: (0, field_1.optionalString)('Street address'),
    addressExtra: (0, field_1.optionalString)('Additional address line'),
    zip: (0, field_1.optionalString)('Postal code'),
    city: (0, field_1.optionalString)('City'),
    state: (0, field_1.optionalString)('State or province'),
    country: (0, field_1.optionalString)('Country'),
    countryCode: (0, field_1.optionalString)('Country code'),
    mobilePhoneNumber: (0, field_1.optionalString)('Deprecated alias stored as contactInfo.phoneNumber'),
    phoneNumber: (0, field_1.optionalString)('Contact phone number'),
    email: (0, field_1.optionalString)('Contact email'),
    contactName: (0, field_1.optionalString)('Contact name'),
    customerAccountId: (0, field_1.optionalString)('Customer account id. Sent on PUT or PATCH it is not stored, and the stored one is lost'),
};
const coordinate = (description) => effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }).annotations({ description });
exports.CreatePayload = effect_1.Schema.Struct({
    serialNumber: (0, field_1.nonEmpty)('Device serial number; its model code must be a known v1 model'),
    name: (0, field_1.nonEmpty)('Device display name'),
    model: (0, field_1.optionalString)('Legacy model code; when supplied it must match the serial number'),
    lat: coordinate('Latitude'),
    lon: coordinate('Longitude'),
    registrationToken: (0, field_1.optionalString)('Registration token'),
    ...contactAndAddressFields,
}).annotations({
    identifier: `${exports.NAMESPACE}.CreatePayload`,
    description: 'Registers a v1 device to the caller. Unlike the admin contract, name is required here.',
});
exports.UpdatePayload = effect_1.Schema.Struct({
    serialNumber: (0, field_1.nonEmpty)('Device serial number'),
    name: (0, field_1.optionalString)('Device display name; an empty value is ignored'),
    lat: coordinate('Latitude'),
    lon: coordinate('Longitude'),
    ...contactAndAddressFields,
}).annotations({
    identifier: `${exports.NAMESPACE}.UpdatePayload`,
    description: 'Shared by PUT and PATCH. Unlike the admin contract there is no ownerId, tenantId or uuid.',
});
exports.CommandPayload = effect_1.Schema.Struct({
    ...schema_1.SendCommandPayload.fields,
    requestId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Id of the sent command, generated when omitted. Ignored when the command is delivered as a job',
    }),
    deferrable: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true }).annotations({
        description: 'When true, delivery is forced to job, whatever delivery says',
    }),
    delivery: effect_1.Schema.optionalWith(effect_1.Schema.Literal('auto', 'job', 'instant'), { exact: true }).annotations({
        description: 'instant (default) calls the device now; job queues an on-demand command job; auto calls the device when its stored status is online and falls back to a job otherwise',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.CommandPayload`,
    description: 'deviceId is not an alias for serialNumber',
});
exports.CommandSent = effect_1.Schema.Struct({
    requestId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Id of the sent command, generated when the caller sent none',
    }),
    deliveryStatus: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Delivery status reported by the messaging service, when it reports one',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.CommandSent`,
    description: 'The device reply itself is not returned, only recorded in the command history',
});
exports.CommandQueued = effect_1.Schema.Struct({
    requestId: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.String)).annotations({
        description: 'Id of the sent command, generated when the caller sent none',
    }),
    deliveryStatus: effect_1.Schema.Literal('Queued'),
    reason: effect_1.Schema.String,
    queueId: effect_1.Schema.optionalWith(Json.Value, { exact: true }).annotations({
        description: 'Queue id as reported by the bridge',
    }),
    pendingCount: effect_1.Schema.optionalWith(Json.Value, { exact: true }).annotations({
        description: 'Messages waiting in the bridge queue, as reported by the bridge',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.CommandQueued`,
    description: 'The bridge accepted the command and owns the retry',
});
exports.Config = effect_1.Schema.Struct({
    version: effect_1.Schema.propertySignature((0, field_1.dateTime)('Creation time of the configuration record')),
    schemaVersion: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.Number)).annotations({
        description: 'Schema version stored with the configuration, null when none was stored',
    }),
    config: effect_1.Schema.propertySignature(Json.Record).annotations({
        description: 'The stored settings without the schemaVersion key',
    }),
    createdAt: effect_1.Schema.propertySignature((0, field_1.dateTime)('Creation time')),
    appliedAt: effect_1.Schema.optionalWith(effect_1.Schema.NullOr((0, field_1.dateTime)('Time the device applied it')), {
        exact: true,
    }).annotations({
        description: 'Always null: nothing in this codebase marks a configuration as applied, both writers store applied false and appliedAt null',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.Config`,
});
exports.ConfigPayload = effect_1.Schema.Struct({
    serialNumber: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'Device serial number. An empty string passes the check and ends up as a 404',
    }),
    schemaVersion: effect_1.Schema.propertySignature(effect_1.Schema.Number.pipe(effect_1.Schema.greaterThanOrEqualTo(1))).annotations({
        description: 'Schema version of the settings, a number from 1 (a fraction is accepted)',
    }),
    config: effect_1.Schema.propertySignature(Json.Record.pipe(effect_1.Schema.filter(settings => Object.keys(settings).length >= 1, {
        jsonSchema: { type: 'object', minProperties: 1 },
    }))).annotations({
        description: 'Settings object with at least one key. Keys named like [a-zA-Z0-9_]{1,100} are the checked ones, other keys are not rejected; a schemaVersion key here is overwritten by the schemaVersion field',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.ConfigPayload`,
});
//# sourceMappingURL=schema.js.map